import 'dom4';
import { getEdgeVersion, isIE } from './utils/browser';

async function bootUp () {
  // eslint-disable-next-line no-alert
  const { 'default': bannerMessage } = await import(
    /* webpackChunkName: "banner-message" */
    './banner-message'
  );

  if (isIE()) {
    // Legacy won't automatically append the bannerMessage stylesheet
    const stylesheet = document.createElement('link');
    stylesheet.href = 'Scripts/dist-legacy/main.css';
    stylesheet.rel = 'stylesheet';

    document.body.appendChild(stylesheet);

    bannerMessage(
      'We are no longer supporting Internet Explorer. ' +
        'Please use the latest version of Google Chrome, Mozilla Firefox, ' +
        'Safari, or Microsoft Edge.'
    );
    return;
  }

  const edgeVersion = getEdgeVersion();

  if (edgeVersion !== null && edgeVersion <= 18) {
    bannerMessage(`Please install the <a
      href="https://www.microsoft.com/en-us/edge/"
      target="_blank"
      rel="noopener"
      style="font-weight: bold; text-decoration: underline;"
      >latest version of Microsoft Edge</a>.`);
  }
}

bootUp()
  .then(() => {
    document.getElementById('centerMenu').hidden = true;
  })
  .catch(console.error);
